export default __webpack_public_path__ + "static/media/logo.688005ac.svg";